import React from 'react'
import PropTypes from 'prop-types'
import ChannelSelect from 'components/ChannelSelect'
import {Table, Column, Cell} from 'components/Table'
import URLPart from 'components/URLPart'
import Select from 'components/Select'
import {fetchUnmappedUrls, mapUrlChannel} from 'redux/modules/settings/actions'
import {
  getUnmappedUrls,
  getMapUnmappedChannelSaving
} from 'redux/modules/settings/selectors'
import classnames from 'classnames'
import {connect} from 'react-redux'
import every from 'lodash/every'
import omit from 'lodash/omit'
import AddMappingForm from './AddMappingForm'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'

const checkMappingsOnChannel = (maps, chnls) =>
  every(Object.keys(maps), p => maps[p] === chnls[p])

export class UmMappedView extends React.Component {
  static propTypes = {
    fetchUnmappedUrls: PropTypes.func,
    mapUrlChannel: PropTypes.func,
    unmappedUrls: PropTypes.array,
    isUnmappedUrlFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  static mappingModes = [
    {
      name: 'Url Fragment',
      value: 'url_fragment'
    },
    {
      name: 'Exact url',
      value: 'exact_url'
    },
    {
      name: 'Text',
      value: 'text'
    }
  ]

  constructor(props) {
    super(props)
    this.state = {
      mappingMode: 'url_fragment',
      selectedOrigin: null,
      selectedPathname: null,
      selectedParameters: {},
      selectedChannel: null
    }
  }

  componentWillMount() {
    const {fetchUnmappedUrls} = this.props
    fetchUnmappedUrls()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedUrl: null,
      selectedText: null,
      selectedOrigin: null,
      selectedPathname: null,
      selectedParameters: {},
      selectedChannel: null
    })
  }

  render() {
    return (
      <div className='unmapped-view'>
        {this.renderUnmappedChannels()}
        {this.renderMappingForm()}
      </div>
    )
  }

  renderUnmappedChannels() {
    const {unmappedUrls, isUnmappedUrlFetching} = this.props
    const {mappingMode} = this.state

    return (
      <div className='settings-unmapped-view_channels'>
        <div className='settings-unmapped-view_mode'>
          <Select
            className='aggr-filter_header_select'
            value={this.state.mappingMode}
            options={UmMappedView.mappingModes}
            onSelect={item =>
              this.setState({
                mappingMode: item.value,
                selectedUrl: null,
                selectedText: null,
                selectedOrigin: null,
                selectedPathname: null,
                selectedParameters: {},
                selectedChannel: null
              })
            }
          />
        </div>
        <AddMappingForm
          mappingMode={mappingMode}
          onAdd={({url, text, origin, params, pathname}) => {
            this.setState({
              selectedUrl: url,
              selectedText: text,
              selectedOrigin: origin,
              selectedPathname: pathname,
              selectedParameters: params || {}
            })
          }}
        />
        <div className='settings-unmapped-view_channels_intro'>
          Below a list of URLs that are not matching to any rules either for UTM
          mapping or custom mapping
        </div>
        <Table
          className='settings-unmapped-view_channels_table'
          data={unmappedUrls}
          loading={isUnmappedUrlFetching}
          empty='There are no unmapped channels'
        >
          <Column
            header='URLs'
            grow
            cell={data => (
              <Cell className='settings-unmapped-view_channels_table_url-cell'>
                {mappingMode === 'exact_url'
                  ? this.renderUnmmappedFullUrl(data)
                  : this.renderUnmappedChannel(data)}
              </Cell>
            )}
          />
          <Column
            header='Channel Group'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelGroupTitle id={data.channelGroup} />
              </Cell>
            )}
          />
          <Column
            header='Channel'
            grow
            width={140}
            cell={data => (
              <Cell>
                <ChannelTitle id={data.channel} iconSize='16px' />
              </Cell>
            )}
          />
          <Column
            header='Visits'
            width='100px'
            className='settings-unmapped-view_channels_table_visits'
            cell={data => <Cell className=''>{data.visits}</Cell>}
          />
        </Table>
      </div>
    )
  }

  renderUnmmappedFullUrl(data) {
    const {url} = data
    const {selectedUrl} = this.state

    const isUrlActive = selectedUrl === url

    const classNames = classnames('settings-unmapped-view_url', {
      'is-matched': !selectedUrl || selectedUrl === url
    })

    return (
      <div className={classNames}>
        <URLPart
          index={-1}
          type={''}
          value={url}
          active={isUrlActive}
          onClick={() => this.setState({selectedUrl: selectedUrl ? null : url})}
        />
      </div>
    )
  }

  renderUnmappedChannel(data) {
    const {origin, pathname, params} = data
    const {selectedOrigin, selectedPathname, selectedParameters, mappingMode} =
      this.state
    const matchedChannel = checkMappingsOnChannel(selectedParameters, {
      origin,
      pathname,
      ...params
    })

    const classNames = classnames('settings-unmapped-view_url', {
      'is-matched': matchedChannel
    })

    const isOriginActive = selectedOrigin && selectedOrigin === origin
    const isPathActive = selectedPathname && selectedPathname === pathname
    const isDisabel = mappingMode === 'text'
    return (
      <div className={classNames}>
        <URLPart
          index={-1}
          type={''}
          value={origin}
          active={isOriginActive}
          disabled={isDisabel}
          onClick={() =>
            this.setState({selectedOrigin: selectedOrigin ? null : origin})
          }
        />
        {pathname ? (
          <URLPart
            index={-1}
            type={''}
            value={pathname}
            active={isPathActive}
            disabled={isDisabel}
            onClick={() =>
              this.setState({
                selectedPathname: selectedPathname ? null : pathname
              })
            }
          />
        ) : null}

        {Object.keys(params).map((channel, index) => {
          const value = params[channel]
          const active =
            selectedParameters[channel] && selectedParameters[channel] === value
          return (
            <URLPart
              key={index}
              index={index}
              type={channel}
              value={value}
              disabled={isDisabel}
              active={active}
              onClick={this.handleMappingClick}
            />
          )
        })}
      </div>
    )
  }

  renderMappingForm() {
    return (
      <div className='settings-unmapped-view_form'>
        <div className='settings-unmapped-view_form_title'>
          Create a new mapping
        </div>
        {this.renderMappings()}
        {this.renderChannelSelect()}
      </div>
    )
  }

  renderMappings() {
    const {
      mappingMode,
      selectedText,
      selectedUrl,
      selectedOrigin,
      selectedPathname,
      selectedParameters
    } = this.state
    const renderFullUrl = () =>
      selectedUrl ? (
        <div className='settings-unmapped-view_form_mapping'>{selectedUrl}</div>
      ) : null

    const renderUrlStruct = () => (
      <>
        {selectedOrigin || selectedPathname ? (
          <div className='settings-unmapped-view_form_mapping'>
            {[
              selectedOrigin,
              selectedPathname,
              Object.keys(selectedParameters).length ? '?' : ''
            ].join('')}
          </div>
        ) : null}
        {Object.keys(selectedParameters).map((param, index) => {
          const value = selectedParameters[param]
          if (!value) return null

          const paramValue = `${param}=${value}`
          return (
            <div key={index} className='settings-unmapped-view_form_mapping'>
              {paramValue}
            </div>
          )
        })}
      </>
    )

    const renderText = () =>
      selectedText ? (
        <div className='settings-unmapped-view_form_mapping'>
          {selectedText}
        </div>
      ) : null

    return (
      <div className='settings-unmapped-view_form_mappings'>
        From now on, whenever we encounter the selected url we will map to this
        channel:
        {
          mappingMode === 'exact_url' ? renderFullUrl() : mappingMode === 'text' ? renderText() : renderUrlStruct()
        }
      </div>
    )
  }

  renderChannelSelect() {
    const {selectedChannel} = this.state
    const disabled = !(this.hasActiveUrl() && selectedChannel)

    return (
      <div className='settings-unmapped-view_form_channel'>
        <ChannelSelect
          className='settings-unmapped-view_form_select'
          value={selectedChannel}
          onChannelSelect={this.selectChannel}
        />

        <button
          type='submit'
          className='settings-unmapped-view_form_submit'
          onClick={this.saveUrlMapped}
          disabled={disabled}
        >
          Save
        </button>
      </div>
    )
  }

  handleMappingClick = (type, value, active) => {
    const {selectedParameters} = this.state
    const isSelect = active || !selectedParameters[type]
    const parameterValue = isSelect ? value : null

    if (parameterValue) {
      this.setState({
        selectedParameters: {
          ...selectedParameters,
          [type]: parameterValue
        }
      })
    } else {
      this.setState({
        selectedParameters: omit(selectedParameters, [type])
      })
    }
  }

  hasActiveUrl() {
    const {
      selectedUrl,
      selectedText,
      selectedOrigin,
      selectedPathname,
      selectedParameters
    } = this.state

    return (
      selectedUrl ||
      selectedText ||
      selectedOrigin ||
      selectedPathname ||
      Object.keys(selectedParameters).find(param => !!selectedParameters[param])
    )
  }

  selectChannel = item => {
    if (!item) {
      this.setState({selectedChannel: null})
    } else {
      const {channelTypeId, channelGroupId, channelId} = item
      if (!channelGroupId || !channelId) {
        this.setState({selectedChannel: null})
      } else {
        this.setState({
          selectedChannel: {channelTypeId, channelGroupId, channelId}
        })
      }
    }
  }

  saveUrlMapped = () => {
    const {mapUrlChannel} = this.props
    const {
      mappingMode,
      selectedText,
      selectedUrl,
      selectedOrigin,
      selectedPathname,
      selectedParameters,
      selectedChannel
    } = this.state

    const disabled = !(this.hasActiveUrl() && selectedChannel)
    if (disabled) return

    const {channelTypeId, channelGroupId, channelId} = selectedChannel
    const data =
      mappingMode === 'exact_url' ? {selectedUrl} : mappingMode === 'text' ? {selectedText} : {
        selectedOrigin,
        selectedPathname,
        selectedParameters
      }

    mapUrlChannel({
      ...data,
      channelTypeId,
      channelGroupId,
      channelId
    })
  }
}

const mapStateToProps = state => ({
  unmappedUrls: getUnmappedUrls(state),
  isMapUnmappedChannelSaving: getMapUnmappedChannelSaving(state),
  isUnmappedUrlFetching: state.settings.isUnmappedUrlFetching
})

export default connect(mapStateToProps, {
  fetchUnmappedUrls,
  mapUrlChannel
})(UmMappedView)



// WEBPACK FOOTER //
// ./client/views/SettingsCustomMappingView/UnMappedView.js